import { IconButton, Stack, Tooltip } from "@mui/material";
import { OrdersActionCellItems } from "./OrdersActionCellItems";
import { useEffect, useState } from "react";
import { OrderActionDrawer } from "./OrderActionsDrawer/OrderActionDrawer";
import React from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import { ShipmentsLogsDrawer } from "../ShipmentsTable/ShipmentsLogsDrawer/ShipmentsLogsDrawer";
import { useAmazonWIrefresh } from "../../hooks/useAmazonWIRefresh";

interface ActionCellCellProps extends CustomCellRendererProps {
  refreshData: () => void;
  setSnackBar: (snackBar: { open: boolean; message: string; severity: string }) => void;
}

export const OrdersActionCell = React.memo((params: ActionCellCellProps) => {
  const { data, refreshData, setSnackBar } = params;
  const [shipmentLogsDrawerOpen, setShipmentLogsDrawerOpen] = useState(false);
  const [orderActionDrawer, setOrderActionDrawer] = useState<boolean>();

  const onActionClick = () => {
    setOrderActionDrawer(true);
  };
  const handleActionDrawerClose = () => {
    setOrderActionDrawer(false);
  };

  const handleOnSuccess = (updateActionResponseData) => {
    if (updateActionResponseData.success === true) {
      setOrderActionDrawer(!orderActionDrawer);
      setSnackBar({
        open: true,
        message: "Action Update Success",
        severity: "success",
      });
      refreshData();
    } else {
      setOrderActionDrawer(!orderActionDrawer);
      setSnackBar({
        open: true,
        message: " The Action update not success",
        severity: "error",
      });
    }
  };

  const onClickLogs = () => {
    setShipmentLogsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setShipmentLogsDrawerOpen(false);
  };

  const onValidationDrawer = () => {
    setShipmentLogsDrawerOpen(false);
  };

  // TODO: Add callbacks here
  const actions = OrdersActionCellItems({ onLogsClick: onClickLogs, onActionClick: onActionClick });

  //Focus needed on multiple occurence of the search api when user clicks on the amazon refetch button

  const [amazonWIrefreshPayloadData, setAmazonWIrefreshPayloadData] = useState([]);
  const [amazonWIrefetchEnable, setAmazonWIrefreshEnable] = useState<boolean>(false);

  //AmazonWi refresh API hook
  const { loadingAmazonWI, fetchingAmazonWI, errorFetchingAmazonWI, AmazonWIResponseData, fetchAmazonWIError, refetchAmazonWI } =
    useAmazonWIrefresh({ amazonWIdata: amazonWIrefreshPayloadData, enabled: amazonWIrefetchEnable });

  //Snackbar for the AmazonWI API response
  useEffect(() => {
    if (AmazonWIResponseData?.success === true) {
      setOrderActionDrawer(false);
      setSnackBar({
        open: true,
        message: AmazonWIResponseData?.message,
        severity: "success",
      });
      refreshData();
    } else if (AmazonWIResponseData?.success === false) {
      setOrderActionDrawer(false);
      setSnackBar({
        open: true,
        message: AmazonWIResponseData?.message,
        severity: "error",
      });
    }
  }, [AmazonWIResponseData, amazonWIrefetchEnable]);

  //Handle amazonWI api
  const handleOnSuccessfulAmazonWI = (data) => {
    setAmazonWIrefreshPayloadData([data]);
    setAmazonWIrefreshEnable(true);
  };

  useEffect(() => {
    setAmazonWIrefreshEnable(false);
  }, [amazonWIrefetchEnable]);

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={2}>
        {actions.map(({ component: IconComponent, onClick, name }, key) => (
          <Tooltip key={key} title={name} arrow>
            <IconButton key={key} onClick={onClick}>
              <IconComponent />
            </IconButton>
          </Tooltip>
        ))}
      </Stack>
      <ShipmentsLogsDrawer
        key={data._id} // Use data._id instead of looping over orderIds
        open={shipmentLogsDrawerOpen}
        onClose={handleDrawerClose}
        onValidation={onValidationDrawer}
        shipmentLogsData={data.historyList}
        orderId={data._id}
      />
      <OrderActionDrawer
        data={data}
        onOpen={orderActionDrawer}
        OnClose={handleActionDrawerClose}
        onSuccessfulUpdate={handleOnSuccess}
        onSuccessfulAmazonRefresh={handleOnSuccessfulAmazonWI}
      />
    </>
  );
});
